import {$$} from './util/$$';
import {$} from './util/$';

const CONTAINER_SELECTOR: string = '.js-accordion';
const ITEM_SELECTOR: string = '.js-accordion__item';
const TRIGGER_SELECTOR: string = '.js-accordion__trigger';
const ACTIVE_CLASS: string = 'active';

class Accordion {
    private _active: HTMLElement | undefined;

    public constructor(container: HTMLElement) {
        $$(ITEM_SELECTOR, container).forEach((item: HTMLElement): void => {
            this.handleItem(item);
        });
    }

    private handleItem(item: HTMLElement): void {
        const trigger: HTMLElement | undefined = $(TRIGGER_SELECTOR, item);

        if (trigger === undefined) {
            return;
        }

        trigger.addEventListener('click', (): void => {
            this.toggle(item);
        });
    }

    private toggle(item: HTMLElement): void {
        if (this._active === item) {
            this._active.classList.remove(ACTIVE_CLASS);
            this._active = undefined;

            return;
        }

        if (this._active !== undefined) {
            this._active.classList.remove(ACTIVE_CLASS);
        }

        this._active = item;
        this._active.classList.add(ACTIVE_CLASS);
    }
}

export function accordion(): void {
    $$(CONTAINER_SELECTOR).map(
        (element: HTMLElement): Accordion => {
            return new Accordion(element);
        },
    );
}
